import { Asset, AssetsParams, LiveApiAsset } from '@app/modules/location-client/location-api.models';
import { environment } from '@environments/environment';
import { isBoolean } from '@app/modules/shared/utilities/utilities';
import { FiltersState } from '@app/store/filters/models/filters.model';
import { VehicleListItem } from '@app/core/models/zonar-accounts.model';

export const buildAssetsParams = (
  params: AssetsParams,
  filters?: FiltersState,
  vehicles?: VehicleListItem[]
): AssetsParams => {
  const sharedParams = {
    pageSize: environment.liveUpdate.pageSize,
    sortOrder: filters.filter?.sortOrder,
    sortAttribute: filters.filter?.sortAttribute
  };
  // this must be a direct query for a specific asset
  if (params?.assetIds?.length) {
    return {
      ...sharedParams,
      assetIds: params.assetIds
    };
  }

  // this must be a direct query for a specific driver
  if (params.driverProfileId) {
    const assetParams: AssetsParams = {
      ...sharedParams,
      driverProfileId: params.driverProfileId,
      companyId: params.companyId
      // active: true
    };
    if (params.divisionId) {
      assetParams.divisionId = params.divisionId;
    }
    return assetParams;
  }

  const newAssetParams = <AssetsParams>{
    requireDevice: environment.locationApi.hasAssociatedDevice
  };
  newAssetParams.companyId = params?.companyId ? params.companyId : filters.filter?.company?.id;
  // newAssetParams.active = params?.active ? params.active : true;
  newAssetParams.pageSize = params?.pageSize ? params.pageSize : environment.liveUpdate.pageSize;
  // delete newAssetParams.divisionIds;
  // delete newAssetParams.accountDivisions;
  // const divisionIds = filters.filter.locations.map(l => l.id);
  // const accountDivisions = filters.filter.divisions.filter(l => l.legacyType === 'LEGACY').map(l => l.id);
  // if (divisionIds.length) {
  //   newAssetParams.divisionIds = divisionIds;
  // } else if (accountDivisions.length) {
  //   newAssetParams.accountDivisions = accountDivisions;
  // }
  if (isBoolean(params?.powerOn) && params.powerOn) {
    newAssetParams.powerOn = params.powerOn;
  } else if (isBoolean(filters.filter?.powerOn) && filters.filter.powerOn) {
    newAssetParams.powerOn = filters.filter.powerOn;
  }
  newAssetParams.sortOrder = params?.sortOrder ? params.sortOrder : filters.filter?.sortOrder;
  newAssetParams.sortAttribute = params?.sortAttribute ? params.sortAttribute : filters.filter?.sortAttribute;
  if (filters.filter?.driver?.id) {
    newAssetParams.driverProfileId = filters.filter.driver.id;
  }

  if (vehicles?.length) {
    const vins = vehicles.map(item => item.vin).filter(vin => !!vin && !!vin.trim());
    newAssetParams.vins = vins;
  }

  // Do not use Search term filter as it uses elastic search
  // const searchTerms = params?.searchTerms?.length > 0 ? params.searchTerms : filters.filter?.searchTerms;
  // newAssetParams.searchTerms = searchTerms.map(searchTerm => searchTerm.split(' ')).flat();
  return newAssetParams;
};

export const objectShallowEquality = <Type>(previous: Type, next: Type): boolean => {
  // https://blog.bitsrc.io/how-to-compare-objects-in-javascript-f4eafef807fc
  let len = null;

  if (!previous || !next) {
    return false;
  }
  if (Object.keys(previous).length !== Object.keys(next).length) {
    return false;
  } else {
    len = Object.keys(previous).length;
  }
  let matches = 0;
  Object.keys(previous).forEach(key => {
    if (previous[key] === next[key]) {
      matches += 1;
    }
  });
  return matches === len;
};

// keep zonar structure for refacto
export const convertToAsset = (source: LiveApiAsset): Asset => {
  return {
    assetId: source.id,
    companyId: source.accountId,
    assetTypeInfo: {
      vin: source.vin
    },
    latitude: source.latitude,
    longitude: source.longitude,
    geoEventTs: source.geoEventTs,
    powerOn: source.powerOn,
    heading: source.heading,
    odometer: source.odometer,
    idling: source.idling,
    speed: source.speed,
    driverProfileId: source.drivercardId,
    legacyAttributes: {
      gpssn: source.deviceId
    },
    connectionIssue: source.connectionIssue
  };
};
